"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGGED_ERROR_FIELDS = void 0;
exports.makeLoggableError = makeLoggableError;
/**
 * The list of fields included in the {@link makeLoggableError} return. At this
 * time, it is not customizable.
 */
const LOGGED_ERROR_FIELDS = exports.LOGGED_ERROR_FIELDS = ["message", "name", "type", "code", "cause", "status", "stack", "moreInfo"];

/**
 * Element of {@link LOGGED_ERROR_FIELDS}.
 */

/**
 * Given any thrown exception, turn it into an object fit to send to
 * {@link LogApi}.
 *
 * This returns the values of common error fields. Values in other fields are
 * dropped. The fields returned are those in {@link LOGGED_ERROR_FIELDS}.
 *
 * @example
 * import {makeLoggableError} from "@aops-trove/fast-log";
 * try {
 *   doFallibleOperation();
 * } catch (ex: unknown) {
 *   log.error({error: makeLoggableError(ex)}, "FallibleOperation did a fallible");
 * }
 */
function makeLoggableError(e) {
  if (!e || typeof e !== "object") {
    return {};
  }
  const ret = {};
  LOGGED_ERROR_FIELDS.forEach(k => {
    if (k in e) {
      ret[k] = e[k];
    }
  });
  return ret;
}
//# sourceMappingURL=Errors.js.map